import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { RESULTS_HEADER_BACK } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-results-header',
    templateUrl: './results-header.component.html',
    styleUrls: ['./results-header.component.scss'],
    standalone: false
})
export class ResultsHeaderComponent implements OnInit {
  @Output() onBackClick = new EventEmitter<void>();

  /**
   * a11y: when true, the back chevron is marked as cdkFocusInitial so
   * CDK FocusTrap (in the parent slide-up-card dialog) puts initial focus
   * here on dialog open. Audit asked that focus jump to the close button
   * at the top of the dialog before reaching the title/content.
   */
  @Input() focusInitialOnBack: boolean = false;

  iconName: string;
  /**
   * a11y: localized accessible name for the back chevron (icon-only
   * mot-button). Without it SR users heard just "button" with no purpose.
   */
  backButtonAriaLabel: string = '';

  constructor(private readonly languageService: LanguageService) { }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.iconName = language.direction === "rtl" ? "chevron-right" : "chevron-left"
      this.backButtonAriaLabel = RESULTS_HEADER_BACK[language.language];
    })
  }
}
